import { css } from '@emotion/react';

export const container = css({
  position: 'absolute',
  left: '0px',
  top: '0px',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  zIndex: -10
});

export const canvas = css({
  width: '100%',
  height: '100%'
});

export const image = css({
  display: 'none'
});
